var map = {
	"./bg-counter.jpg": 790,
	"./ingredients-apples.png": 791,
	"./ingredients-beets.png": 792,
	"./ingredients-coconut.png": 793,
	"./ingredients-green-peas.png": 794,
	"./ingredients-mung-beans.png": 795,
	"./ingredients-pomegranate.png": 796,
	"./ingredients-pompergrant.png": 797,
	"./ingredients-potatoes.png": 798,
	"./ingredients-rice.png": 799,
	"./ingredients-yellow-peas.png": 800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 789;